import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, Outlet } from 'react-router-dom';
import { API_URL, APP_URL, FILE_URL, NO_IMG } from '../../constants';
import EditProfile from './EditProfile';
import axios from 'axios';
import { toast } from 'react-toastify';
import ChangePassword from './ChangePassword';
import AdminUserAddresses from './Addresses';
import LoadingDashboardContent from '../../components/LoadingDashboardContent';
import { useTokens } from '../../context/TokenContext';

const AdminCustomerEdit = ({ id }) => {
  const { getItem } = useTokens();
  const adminAuthToken = getItem('admin', 'AuthToken');
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isReload, setIsReload] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${API_URL}/admin/user/${id}`, {
          headers: { 'Authorization': `Bearer ${adminAuthToken}` },
        });
        if (response.status === 200) {
          setFormData(response.data);
        }
      } catch (error) {
        toast.error('Failed to fetch user data.');
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [id, isReload]);

  const basic = formData?.basic || {};
  const userName = `${basic.first_name || ''} ${basic.last_name || ''}`.trim();
  const userRole = basic.roles || '';
  const profilePicture = basic.profile_picture || '';

  return (
    <div>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">Edit Customer</h1>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Link to={`${APP_URL}admin/customer`}>
            <button type="button" className="btn btn-sm btn-outline-secondary rounded-0">
              <i className="bi bi-arrow-left me-2"></i> Back to List
            </button>
          </Link>
        </div>
      </div>

      { loading ? <LoadingDashboardContent / > : (
      <div className="row g-4 pt-1">
        <div className="col-md-3 col-lg-3">
          <div className="card mb-4">
            <div className="align-items-center d-flex">
              <div>
                <img
                  src={profilePicture && profilePicture.trim() !== '' ? `${FILE_URL}${profilePicture}` : NO_IMG}
                  className="img-fluid rounded-circle ratio-1x1 img-thumbnail object-fit-cover"
                  alt="User Avatar"
                  style={{ width: 80, height: 80 }}
                />
              </div>
              <div>
                <div className="card-body p-2">
                  <span className="small text-muted fwt-italic">Hello,</span>
                  <h6 className="text-muted m-0 p-0">{userName}</h6>
                  <span className="small text-info" style={{ 'fontSize': 12 }}>({userRole})</span>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <ul className="list-group list-group-flush">
              <li className="list-group-item list-group-item-action">
                <Link to={`${APP_URL}admin/customer/edit/${id}/profile`} className="d-block text-dark text-decoration-none">
                  <i className="bi bi-person"></i> Profile
                </Link>
              </li>
              <li className="list-group-item list-group-item-action">
                <Link to={`${APP_URL}admin/customer/edit/${id}/addresses`} className="d-block text-dark text-decoration-none">
                  <i className="bi bi-geo-alt"></i> Manage Addresses
                </Link>
              </li>
              <li className="list-group-item list-group-item-action">
                <Link to={`${APP_URL}admin/order/all?page=1&limit=20&searchBy=customer_id&searchValue=${id}`} className="d-block text-dark text-decoration-none">
                  <i className="bi bi-view-list"></i> Orders
                </Link>
              </li>
              <li className="list-group-item list-group-item-action">
                <Link to={`${APP_URL}admin/customer/edit/${id}/change-password`} className="d-block text-dark text-decoration-none">
                  <i className="bi bi-fingerprint"></i> Security
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-9 col-lg-9">
          <div className="card">
            <div className="card-body p-4">
              <Routes>
                <Route index element={<EditProfile id={id} data={formData} onUpdate={() => setIsReload(!isReload)} />} />
                <Route path="profile" element={<EditProfile id={id} data={formData} onUpdate={() => setIsReload(!isReload)} />} />
                <Route path="addresses" element={<AdminUserAddresses id={id} />} />
                <Route path="change-password" element={<ChangePassword id={id} />} />
              </Routes>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default AdminCustomerEdit;
